import { Box, BoxProps, Typography, useTheme } from '@mui/material';
import { tokens } from '@app/theme/themes';
import { FC, ReactNode } from 'react';

interface PageHeaderProps extends BoxProps {
    title: string;
    subtitle?: string;
    beforeContent?: ReactNode;
}

const PageHeader: FC<PageHeaderProps> = ({ title, subtitle, beforeContent, ...props }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box sx={{ mb: 2, display: 'flex', gap: 1, ...props?.sx }} {...props}>
            {beforeContent}
            <Typography
                variant="h2"
                sx={{
                    color: colors.grey[100],
                    fontWeight: 700,
                }}
                className="page-header__title"
                data-testid="page_title"
            >
                {title}
            </Typography>
            {subtitle && <Typography variant="h6">{subtitle}</Typography>}
        </Box>
    );
};

export default PageHeader;
